export default "__VITE_ASSET__D4Vr$AVY__"